import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import index from '@/components/index'
import list from '@/components/list'
import aboutUs from '@/components/page/aboutUs'
import addAppointment from '@/components/page/addAppointment'
import appointDetail from '@/components/page/appointDetail'
import forget from '@/components/page/forget'
import allAppointments from '@/components/page/allAppointments'
import selectPart from '@/components/page/selectPart'
import resetPsw from '@/components/page/resetPsw'
import mineDetail from '@/components/page/mineDetail'
import editAppointment from '@/components/page/editAppointment'
import darftList from '@/components/page/darftList'
import copyAppointment from '@/components/page/copyAppointment'
import copyDetailAppointment from '@/components/page/copyDetailAppointment'
import copyAddAppointment from '@/components/page/copyAddAppointment'
import satisfactionSurvey from '@/components/satisfactionSurvey'
import system from '@/components/page/system'
import projectWarn from '@/components/page/projectWarn'
import customer from '@/components/customerReception/customer'
import reception from '@/components/customerReception/reception'
import allCustomer from '@/components/customerReception/allCustomer'
import addCustomer from '@/components/customerReception/addCustomer'
import confirm from '@/components/customerReception/confirm'
import receptionDetails from '@/components/customerReception/receptionDetails'

Vue.use(Router)

export default new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'idnex',
        //     component: index
        // },
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            meta: {
                keepAlive: true,
                ifDoFresh: false,
                showTab: true,
            }

        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs,
            meta: {
                showTab: true,
            }
        },
        {
            path: '/addAppointment',
            name: 'addAppointment',
            component: addAppointment,
            // meta: {
            //     isRefresh: true
            // }
        },
        {
            path: '/appointDetail',
            name: 'appointDetail',
            component: appointDetail,

        },
        {
            path: '/forget',
            name: 'forget',
            component: forget
        },
        {
            path: '/allAppointments',
            name: 'allAppointments',
            component: allAppointments,
            meta: {
                keepAlive: true,
                ifDoFresh: false
            }
        },
        {
            path: '/selectPart',
            name: 'selectPart',
            component: selectPart
        },
        {
            path: '/resetPsw',
            name: 'resetPsw',
            component: resetPsw
        },
        {
            path: '/mineDetail',
            name: 'mineDetail',
            component: mineDetail
        },
        {
            path: '/editAppointment',
            name: 'editAppointment',
            component: editAppointment
        },
        {
            path: '/list',
            name: 'list',
            component: list
        },
        {
            path: '/darftList',
            name: 'darftList',
            component: darftList,
        },
        {
            path: '/copyAppointment',
            name: 'copyAppointment',
            component: copyAppointment,
        },
        {
            path: '/copyDetailAppointment',
            name: 'copyDetailAppointment',
            component: copyDetailAppointment,
        },
        {
            path: '/copyAddAppointment',
            name: 'copyAddAppointment',
            component: copyAddAppointment,
        },
        {
            path: '/satisfactionSurvey',
            name: 'satisfactionSurvey',
            component: satisfactionSurvey,
        },
        {
            path: '/system',
            name: 'system',
            component: system,
        },
        {
            path: '/projectWarn',
            name: 'projectWarn',
            component: projectWarn,
        },
        {
            path: '/customer',
            name: 'customer',
            component: customer,
            meta: {
                showTab: true,
            }
        },
        {
            path: '/reception',
            name: 'reception',
            component: reception,
            meta: {
                showTab: true,
            }
        },
        {
            path: '/allCustomer',
            name: 'allCustomer',
            component: allCustomer,
        },
        {
            path: '/addCustomer',
            name: 'addCustomer',
            component: addCustomer,
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: confirm,
        }, {
            path: '/receptionDetails',
            name: 'receptionDetails',
            component: receptionDetails,
        },
    ],
    scrollBehavior: () => {
        history.pushState(null, null, document.URL)
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js